const styles = {

  parentDiv: {
    minHeight: 50,
    width: '100%',
    float: 'left',
    margin: '5px 0 0px 0',
  },

  input: {
    marginTop: 0,
    border: '1px solid',
    borderColor: '#dbdddd',
    borderBottom: 0,
    borderRadius: 0,
    paddingLeft: 12,
    width: '75%',
    height: '60%',
  },
  underlineDefault: {
    bottom: '27px',
    borderWidth: 1,
    borderColor: '#000000',
    width: '75%',
  },
//changed the border color because of PRODDEF-11827
  underlineFocus: {
    bottom: '27px',
    borderColor: '#000000',
    width: '75%',
  },
  hintStyle: {
    top: 0,
    padding: '15px',
  },
  countryListStyle: {
    borderBottom: '1px solid rgb(216, 218, 218)',
    padding: '20px 0px 20px 0px',
    listStyle: 'none',
    fontSize: '14px',
    fontWeight: 'bold',
    fontStyle: 'normal',
  },
  countryDoubleListWrapStyle: {
    padding: '0px',
    margin: '0px',
    listStyle: 'none',
    display: 'flex',
    flexWrap: 'wrap',
  },
  countryDoubleListStyle: {
    borderBottom: '1px solid rgb(216, 218, 218)',
    padding: '20px 15px 20px 0px',
    listStyle: 'none',
    fontSize: '14px',
    fontStyle: 'normal',
    lineHeight: "15px",
    boxSizing: 'border-box',
  },
  horizinalStyle: {
    margin: '15px -20px',
    borderTop: '1px solid rgb(216, 218, 218)',
  },
  unorderListStyle: {
    margin: '-5px 138px 20px -40px',
  },
  overlayDesktop: {
    // minHeight: '362px',
    // maxHeight: '362px',
    width: '103%',
  },
  overlayMobile: {
    // minHeight: '233px',
    // maxHeight: '233px',
    width: '103%',
  },
  errorStyle: {
    top: '14px',
  },
};

export default styles;

// #b9b6b6
